import Phrase from '../../libs/translationsUtils/phrase'

const TopicTooltip = ({ topic }) => {
  let iconClass = topic.type === 'ideation' ? 'icon--idea' : ' '
  const iconStyle = topic.type === 'ideation' && topic.ideationStatus ? { color: topic.ideationStatus.bgColor } : ''
  const label = topic.type === 'ideation' && topic.ideationStatus ? topic.ideationStatus.name : ''

  if (topic.type !== 'ideation' && topic.contentType !== 'question') {
    return null
  }

  const isAnswered = topic.hasBestAnswer || topic?.features?.[0]?.id === 'isAnswered'
  if (topic.contentType === 'question') {
    iconClass = isAnswered ? 'icon--thread-solved' : 'icon--question-circle'
  }

  return (
    <Phrase p={isAnswered ? 'beantwoord' : 'vraag'}>
      {labelPhrase => {
        return (
          <div
            class='tooltip tooltip--day tooltip--thread-type'
            title={topic.type === 'post' ? labelPhrase : label}
          >
            <div class='js-tooltip-trigger' aria-haspopup='true'>
              <i class={'icon--auto-width ' + iconClass} style={iconStyle} />
            </div>
          </div>
        )
      }}
    </Phrase>
  )
}

export default TopicTooltip
